import classNames from 'classnames';
import React from 'react';
import {applicantOptions} from '../../utils/constants';
import InputField from '../ui/InputField';
import TextArea from '../ui/TextArea';
import FormItem from './FormItem';

const requiredFieldList = [
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Email address',
    key: 'email',
  },
  {
    label: 'Phone number',
    key: 'phone',
  },
  {
    label: 'CV',
    key: 'cv',
  },
  {
    label: 'Cover latter',
    key: 'coverLatter',
  },
];

const LabeledRadioButton = ({label, name, value, register, index}) => {
  const inputId = label + index;
  return (
    <div className="flex gap-2 items-center">
      <InputField
        type="radio"
        name={name}
        value={value}
        id={inputId}
        {...register(name)}
      />
      <label htmlFor={inputId} className="cursor-pointer">
        {label}
      </label>
    </div>
  );
};

const ApplicantDetailsForm = ({jobFormHook}) => {
  const {
    register,
    formState: {errors},
  } = jobFormHook;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h3 className="text-xl font-medium mb-6">Required fields</h3>
        <div className="flex flex-col">
          {requiredFieldList.map(({label, key}, index) => (
            <div
              key={key}
              className={classNames(
                'grid grid-cols-2 justify-center py-3 px-3',
                index % 2 === 0 ? 'bg-gray-200' : '',
              )}
            >
              <div>{label}</div>
              <div className="flex gap-10 align-center">
                {Object.entries(applicantOptions).map(
                  ([applicantOptionValue, applicantOptionLabel]) => (
                    <LabeledRadioButton
                      key={applicantOptionValue}
                      value={applicantOptionValue}
                      label={applicantOptionLabel}
                      name={key}
                      register={register}
                      index={index}
                    />
                  ),
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <FormItem label="Autoreply to candidate" htmlFor="autoReplay">
        <TextArea
          rows="5"
          id="autoReplay"
          {...register('autoReplay')}
          error={errors?.autoReplay?.message}
        />
      </FormItem>
    </div>
  );
};

export default ApplicantDetailsForm;
